export default "__VITE_ASSET__e0bb7afb__"